import StreamingDelivery from "./StreamingDelivery";

export default StreamingDelivery;
